import React from 'react'
import { Filters } from '../Filters'
import { NavBar } from './NavBar'

export const Header = () => {
    return (
        <>
            <NavBar />
        </>
    )
}
